<template>
    <b-carousel
        id="carousel1"
        indicators
        controls
        background="#000"
        :interval="1000000"
        ref="carousel"
    >
        <div v-for="image in images" :key="image">
            <b-carousel-slide>
                <template v-slot:img>
                    <img
                        v-if="image.indexOf('jpg') !== -1"
                        :src="getImageURL(image)"
                        class="content"
                    />
                    <div
                        v-else-if="image.indexOf('player.vimeo.com') !== -1"
                        class="video-wrapper"
                    >
                        <b-embed type="iframe" :src="image" allowfullscreen />
                    </div>
                </template>
            </b-carousel-slide>
        </div>
    </b-carousel>
</template>

<script>
export default {
    name: 'gallery-modal-content',
    props: {
        config: '',
        images: ''
    },
    methods: {
        getImageURL(imageName) {
            return require('../../assets/images/companies/' + imageName)
        },
        handleKeyEvent(e) {
            if (e.keyCode === 39) {
                this.$refs.carousel.next()
            } else if (e.keyCode === 37) {
                this.$refs.carousel.prev()
            }
        }
    },
    mounted: function() {
        window.onkeydown = this.handleKeyEvent
    },
    destroyed: function() {
        window.onkeydown = undefined
    }
}
</script>
<style scoped>
.content {
    width: 100%;
}

.video-wrapper {
    padding: 60px 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/GalleryModalComponent.vue